import React, {Component} from 'react'


class PageTitle extends Component {

  render () {

    window.document.title = this.props.entry.pageTitle ? this.props.entry.pageTitle : 'The Fenway | '+this.props.entry.title;
    return null;
  }
  
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/js/components/PageTitle/PageTitle.jsx